import './App.css';
import HomeComponent from './Components/Home/HomeComponent';
import ModalComponent from './Components/Modal/ModalComponent';

function App() {
  return (
    <>
        <HomeComponent />
    </>
  );
}

export default App;
